import { React, useState, useEffect } from 'react';
import './master.css';
import ApiService from '../../../services/apiService';
import ApiService2 from '../../../../INVENTORY/services/apiService';

import userManagement from '../../../services/userManagement';
import { toast } from 'react-toastify';
import CategoryMasterCard from './categoryCard/categorycard';
import Select from 'react-select';
import { hasPermission } from '../../../services/roleService';
import { useNavigate } from 'react-router-dom';

const AddCategory = () => {
  const [categories, setCategories] = useState([]);
  const [glAccount, setGlAccount] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    GetCategory();
    GetAccount();
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    setPermissions(storedPermissions);
  }, []);

  const [formData, setFormData] = useState({
    category: '',
    glAccountCode: '',
    glAccountName: '',
  });

  const checkPermission = (moduleName, action) => {
    return hasPermission(moduleName, action, permissions);
  };

  const canCreateCategory = checkPermission('Category Master', 'create') || true;
  const canEditCategory = checkPermission('Category Master', 'edit') || true;

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleGLAccounts = (selectedOption) => {
    setFormData({
      ...formData,
      glAccountCode: selectedOption?.value?.accountCode,
      glAccountName: selectedOption?.value?.accountName,
    });
  };

  const CreateCategory = async () => {
    try {
      if (!formData?.category) {
        toast.warning('Please Enter Category Name');
        return;
      }

      if (!formData?.glAccountName || !formData?.glAccountCode) {
        toast.error('Please select GL Account');
        return;
      }

      let UserId = userManagement.getUserId();
      let body = {
        recordId: 0,
        catCode: formData?.category,
        catName: formData?.category,
        loggedInUserId: UserId,
        active: 1,
        glAccountName: formData?.glAccountName,
        glAccountCode: formData?.glAccountCode,
      };

      const apiService = new ApiService();
      let res = await apiService.post('CREATE_CATEGORY', body);

      if (res?.data?.statusCode == 201) {
        toast.success('Category Created Successfully');
        setFormData({
          category: '',
          glAccountCode: '',
          glAccountName: '',
        });
        GetCategory();
      } else {
        toast.error('Failed to create category.');
      }
    } catch (error) {
      console.error('Error creating category:', error);
      toast.error('An unexpected error occurred. Please try again.');
    }
  };

  const GetCategory = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_CATEGORY_MASTER');
      setCategories(res?.data?.result);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const GetAccount = async () => {
    try {
      const apiService = new ApiService2();
      const params = new URLSearchParams();
      params.append('PageNo', 1);
      params.append('PageSize', 50);
      const response = await apiService.getApiParamater('GET_ACCOUNTS', `?${params.toString()}`);
      setGlAccount(response?.data?.result);
    } catch (error) {
      console.error('Error fetching GL ACCOUNT data:', error);
    }
  };

  return (
    <div className="p-5 container">
      <button className="btn addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="catlist">
        <div className="py-3 row">
          <div className="col">
            <label htmlFor="validationCustom01" className="form-label">
              Item Category Name *
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustom01"
              name="category"
              value={formData.category}
              placeholder="Enter Item Category name"
              onChange={handleInputChange}
              disabled={canCreateCategory === true ? false : true}
              required
            />
          </div>
          <div className="col">
            <label htmlFor="validationCustom04" className="form-label">
              Select GL Account *
            </label>
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5' : null,
                  color: state.isFocused ? '#000' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000',
                  },
                }),
              }}
              value={
                glAccount?.find((gl) => gl.accountCode === formData.glAccountCode)
                  ? {
                      value: glAccount.find((gl) => gl.accountCode === formData.glAccountCode),
                      label: glAccount.find((gl) => gl.accountCode === formData.glAccountCode).accountName,
                    }
                  : null
              }
              onChange={handleGLAccounts}
              options={glAccount?.map((gl) => ({ value: gl, label: gl.accountName }))}
              isDisabled={canCreateCategory === true ? false : true}
              placeholder="Select GL Account"
            />
          </div>
        </div>

        <div className="row py-3">
          <div className="col-12 d-flex justify-content-end">
            {canCreateCategory === true ? (
              <button className="addItem-btn" onClick={() => CreateCategory()}>
                Save
              </button>
            ) : (
              <button className="addItem-btn" style={{ cursor: 'not-allowed' }} disabled>
                Save
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="catlist mt-5">
        <div className="row">
          {categories?.map((item) => (
            <CategoryMasterCard key={item.id} val={item} GetCategory={GetCategory} canEditCategory={canEditCategory} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
